import { render, staticRenderFns } from "./MyProposal.html?vue&type=template&id=2e68c00e&"
import script from "./MyProposal.js?vue&type=script&lang=js&"
export * from "./MyProposal.js?vue&type=script&lang=js&"
import style0 from "./MyProposal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports